<template>
	<pop-up-wrapper @close="$emit('close')">
		<div class="pop-up-select-class">
			<img
				class="close"
				@click="$emit('close')"
				src="/img/close.svg"
				alt=""
			/>
			<p class="title">Sélectionner une classe</p>
			<p class="paragraph">
				Choisissez la classe vers laquelle vous souhaitez accéder pour partager vos fichiers.
			</p>
			
			<div class="classes-list">
				<div 
					v-for="classe in classes" 
					:key="classe.id"
					class="class-item"
					@click="selectClass(classe.id)"
				>
					<div class="class-info">
						<h3 class="class-name">{{ classe.name }}</h3>
						<p class="class-details" v-if="classe.level_name">
							Niveau : {{ classe.level_name }}
						</p>
					</div>
					<img src="/img/right-arrow.svg" alt="Accéder" class="arrow-icon" />
				</div>
			</div>
			
			<div v-if="classes.length === 0" class="no-classes">
				<p>Aucune classe disponible</p>
				<router-link 
					class="submit dark" 
					:to="{ name: 'AddClass' }"
					@click="$emit('close')"
				>
					Créer une classe
				</router-link>
			</div>
		</div>
	</pop-up-wrapper>
</template>

<script>
import PopUpWrapper from './PopUpWrapper.vue'

export default {
	components: { PopUpWrapper },
	
	computed: {
		classes() {
			return this.$store.state.classes || []
		}
	},
	
	methods: {
		selectClass(classId) {
			this.$emit('close')
			this.$router.push({
				name: 'ClassDrive',
				params: { id: classId }
			})
		}
	}
}
</script>

<style scoped>
.pop-up-select-class {
	padding: 30px;
	max-width: 500px;
	width: 100%;
}

.close {
	position: absolute;
	top: 20px;
	right: 20px;
	width: 20px;
	height: 20px;
	cursor: pointer;
}

.title {
	font-size: 24px;
	font-weight: bold;
	margin-bottom: 10px;
	color: #333;
}

.paragraph {
	color: #666;
	margin-bottom: 25px;
	line-height: 1.5;
}

.classes-list {
	max-height: 400px;
	overflow-y: auto;
}

.class-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 15px;
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	margin-bottom: 10px;
	cursor: pointer;
	transition: all 0.3s ease;
}

.class-item:hover {
	background-color: #f5f5f5;
	border-color: #007bff;
	transform: translateY(-2px);
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.class-info {
	flex: 1;
}

.class-name {
	font-size: 18px;
	font-weight: 600;
	margin: 0 0 5px 0;
	color: #333;
}

.class-details {
	font-size: 14px;
	color: #666;
	margin: 2px 0;
}

.arrow-icon {
	width: 20px;
	height: 20px;
	opacity: 0.6;
	transition: opacity 0.3s ease;
}

.class-item:hover .arrow-icon {
	opacity: 1;
}

.no-classes {
	text-align: center;
	padding: 30px 0;
}

.no-classes p {
	color: #666;
	margin-bottom: 20px;
}

.submit {
	display: inline-block;
	padding: 12px 24px;
	background-color: #007bff;
	color: white;
	text-decoration: none;
	border-radius: 6px;
	font-weight: 600;
	transition: background-color 0.3s ease;
}

.submit:hover {
	background-color: #0056b3;
}

.submit.dark {
	background-color: #333;
}

.submit.dark:hover {
	background-color: #555;
}
</style>